var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#815500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 4.3h-1.1V.5H3v3.8H2C1.2 4.3.5 5 .5 5.8v4.3c0 .8.7 1.5 1.5 1.5h1v2.5h8.5v-2.5h1.1c.8 0 1.5-.7 1.5-1.5V5.8c0-.8-.6-1.5-1.4-1.5zM4 1.5h6.6v2.8H4zm0 11.7V8.4h6.6V13.2zm8.7-2.5h-1.1V7.5H3v3.2H2c-.3 0-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5h10.6c.3 0 .5.2.5.5v4.3c.1.3-.1.6-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 9.5h4.9v.9H4.8zM4.8 11.5h4.9v.9H4.8z"
  }))));
}
export default SvgPrintIcon;